import React, { useEffect, useRef, useState } from 'react'
import ContainerPage from "../../components/ContainerPage/ContainerPage"
import PageTitle from "../../components/PageTitle/PageTitle"
import TableFooter from "../../components/Pagination/TableFooter"
import { useDispatch } from "react-redux"
import { showSnackBar } from "../../components/Snackbar/Snackbar"
import DebounceInput from "../../components/DebouncedSearch/DebouncedSearch"
import PlusIcon from "../../assets/images/icons/PlusIcon.svg"
import Button from "../../components/Button/Button"
import { useNavigate } from "react-router-dom"
import { fetchUsers } from "../../features/users/users"
import UsersTable from "./UsersTable"
import { useMyContextLoading } from "../../components/LoadingContextProvider/LoadingContextProvider"
import { getListCache, setListCache, clearListCache, buildCacheKey } from "../../utils/listCache"
import { TABLE_CARD } from "../../components/Table/tableCardClass"

const Users = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { triggerBar } = useMyContextLoading()

  const [valuePagination, setValuePagination] = useState(10)
  const [pagePagination, setPagePagination] = useState(1)
  const [pageCount, setPageCount] = useState('')
  const [totalCount, setTotalCount] = useState(null)
  const [handleDelete, setHandleDelete] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [isUpdated, setIsUpdated] = useState(false)

  const [users, setUsers] = useState([])

  const fetchContacts = async () => {
    const cacheKey = buildCacheKey('users', { valuePagination, pagePagination, searchQuery })
    const cached = getListCache(cacheKey)
    if (cached) {
      setUsers(cached.users)
      setPageCount(cached.pageCount)
      setTotalCount(cached.totalCount)
    }
    triggerBar(true)
    try {
      const offset = (pagePagination - 1) * valuePagination

      const response = await dispatch(fetchUsers({
        limit: valuePagination,
        offset,
        searchQuery,
      }))
      const fresh = {
        users: response?.payload?.data?.users,
        pageCount: response?.payload?.data?.meta?.pageCount,
        totalCount: response?.payload?.data?.meta?.totalUsers,
      }
      setUsers(fresh.users)
      setPageCount(fresh.pageCount)
      setTotalCount(fresh.totalCount)
      setListCache(cacheKey, fresh)
    } catch (error) {
      showSnackBar("error", error)
      console.error('An unexpected error occurred:', error)
    }
    triggerBar(false)
  }

  const cacheInvalidateGuard = useRef(true)
  useEffect(() => {
    if (cacheInvalidateGuard.current) {
      cacheInvalidateGuard.current = false
      return
    }
    clearListCache('users')
  }, [handleDelete, isUpdated])

  useEffect(() => {
    fetchContacts()
  }, [searchQuery, handleDelete, valuePagination, pagePagination, isUpdated])

  useEffect(() => {
    setPagePagination(1)
  }, [valuePagination])

  // Typing one or two characters used to do nothing at all, with no explanation.
  const search = (e) => {
    setSearchQuery(e || '')
  }

  return (
    <div className="">
      <ContainerPage>
        <div className="flex justify-between items-center">
          <PageTitle title="Users List" />
          <div className="flex gap-4">
            <Button classes="flex h-9 items-center" onClick={() => navigate("/users/add-user")}>
              <p className={`flex `}>
                <img src={PlusIcon} alt="plus" />
                <p>Add User</p>
              </p>
            </Button>
          </div>
        </div>
        <div className={`${TABLE_CARD} mt-6`}>
          <div className="flex flex-row justify-between items-center px-5 py-4">
            <div className="flex flex-col">
              <div className="flex flex-row">
                <DebounceInput customClassName={'mr-5 b-1'} setSearchValue={search}
                  placeholder="Search..." />
              </div>
            </div>
          </div>
          <UsersTable data={users} setIsUpdated={setIsUpdated} isUpdated={isUpdated} />
          <TableFooter page={pagePagination} limit={valuePagination} total={totalCount}
            pageCount={pageCount} setPage={setPagePagination} setLimit={setValuePagination} />
        </div>
      </ContainerPage>
    </div>
  )
}

export default Users
